import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3e3639ef&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/personal-detail/_personal-detail.scss?vue&type=style&index=0&id=3e3639ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3639ef",
  null
  
)

export default component.exports